import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UtilService } from 'app/shared/util.service';
import { getNpsEbookUrl } from 'app/shared/utils/statics/nps-ebook-links.static';
import { NpsUtilsService } from 'app/new-fs/followup-onsite/summary/nps-widget/services/nps-utils.service';
import { NpsResponse } from '../followup-summary-widgets.utils';

@Component({
  selector: 'mh-surveys-summary-nps',
  templateUrl: './nps-widget.component.html',
  standalone: false,
})
export class NpsWidgetComponent implements OnChanges {
  @Input() npsData: NpsResponse;
  @Input() loading = false;

  npsValue = 0;
  npsPromoters = 0;
  npsPassives = 0;
  npsDetractors = 0;
  npsStatus = '';

  constructor(
    private utilService: UtilService,
    private npsUtilsService: NpsUtilsService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.npsData) {
      if (this.npsData) {
        this.handleSuccess(this.npsData);
      } else {
        this.handleError();
      }
    }
  }

  private handleSuccess(response: NpsResponse): void {
    const data = response.average;
    this.npsValue = data.nps.actual || 0;

    const promoters = data.details.actual.promoters || 0;
    const passives = data.details.actual.passives || 0;
    const detractors = data.details.actual.detractors || 0;
    const total = promoters + passives + detractors;

    this.npsPromoters = total > 0 ? Math.round((promoters / total) * 100) : 0;
    this.npsPassives = total > 0 ? Math.round((passives / total) * 100) : 0;
    this.npsDetractors = total > 0 ? Math.round((detractors / total) * 100) : 0;

    this.npsStatus = this.npsUtilsService.getNpsStatus(this.npsValue) || 'qualifys.nps.no_data';
  }

  private handleError(): void {
    this.npsValue = 0;
    this.npsPromoters = 0;
    this.npsPassives = 0;
    this.npsDetractors = 0;
    this.npsStatus = 'qualifys.nps.no_data';
  }

  onDownloadEbook(): void {
    this.utilService.ga('', 'interchain-followup-npswidget-ebook');
    window.open(getNpsEbookUrl(this.utilService.currentLanguage), '_blank');
  }
}
